function getCollapseStyles(collapseContent, open) {
    if (!collapseContent.current)
        return {};
    if (open) {
        return {
            height: collapseContent.current.scrollHeight + 'px',
        };
    }
    return {
        overflow: 'hidden',
        height: '0',
    };
}

export { getCollapseStyles as default };
